export var ScrollDirection;
(function (ScrollDirection) {
    ScrollDirection["HORIZONTAL"] = "scrollLeft";
    ScrollDirection["VERTICAL"] = "scrollTop";
})(ScrollDirection || (ScrollDirection = {}));
export function doSmoothScroll(element, startPosition, scrollOptions) {
    const { distance, timeSeconds, speed, direction = ScrollDirection.HORIZONTAL, reverseParams, } = scrollOptions;
    let scrollShift = 0;
    let currentTimeChanges = 0;
    const changeScrollFunction = getChangeScrollFunction(direction, Boolean(reverseParams));
    const scrollDistance = (reverseParams === null || reverseParams === void 0 ? void 0 : reverseParams.distance) || distance;
    const timeChanges = getTimeChanges(scrollDistance, timeSeconds, speed);
    while (scrollShift < scrollDistance) {
        window.setTimeout(changeScrollFunction, currentTimeChanges, element, scrollShift, startPosition);
        currentTimeChanges += timeChanges;
        scrollShift++;
    }
}
function getChangeScrollFunction(direction, isReverse) {
    return (element, scrollPosition, startPosition) => {
        // eslint-disable-next-line no-param-reassign, no-not-accumulator-reassign/no-not-accumulator-reassign
        element[direction] = isReverse
            ? startPosition - scrollPosition
            : startPosition + scrollPosition;
    };
}
function getTimeChanges(distance, timeSeconds, acceleration) {
    const physicalSpeed = distance / timeSeconds;
    const programSpeedMilliseconds = (1 / physicalSpeed) * 1000;
    return programSpeedMilliseconds / acceleration;
}
